/**
 * Returns the public Clerk browser key or fails with actionable setup guidance.
 */
export function requireClerkPublishableKey(value: string | undefined): string {
  const publishableKey = value?.trim();

  if (!publishableKey) {
    // LOCAL CHANGE (not upstream): the original message said "add it to the host
    // application environment", which reads like a server-side setting — it sent
    // us to Cloudflare Worker secrets, where a VITE_* variable can never work.
    // Vite inlines these at BUILD time, so the fix is always a build-time file.
    throw new Error(
      'Missing VITE_CLERK_PUBLISHABLE_KEY. This is inlined by Vite at BUILD time, '
      + 'so a Cloudflare Worker secret cannot supply it — the worker serves the '
      + 'bundle, it does not compile it. Set it in .env (committed; publishable '
      + 'keys are public) or .env.local, and rebuild.',
    );
  }

  return publishableKey;
}
